import { IconType, SvgIcon } from './SvgIcon.tsx';

export const PolishFlagIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 12">
    <mask id="mask0_270_55016" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="12">
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55016)">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0V12H16V0H0Z" fill="#F7FCFF" />
      <mask id="mask1_270_55016" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="12">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 0V12H16V0H0Z" fill="white" />
      </mask>
      <g mask="url(#mask1_270_55016)">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 6V12H16V6H0Z" fill="#C51918" />
      </g>
    </g>
  </SvgIcon>
);
